export enum IamPasswordValidationError {
    UNSPECIFIED = 'UNSPECIFIED',
    ON_BLACKLIST = 'ON_BLACKLIST',
    CONTAINS_FORBIDDEN_CHARS = 'CONTAINS_FORBIDDEN_CHARS',
    REQUIRES_CHARS = 'REQUIRES_CHARS',
    SAME_AS_OLD = 'SAME_AS_OLD',
    TOO_LONG = 'TOO_LONG',
    TOO_SHORT = 'TOO_SHORT',
    TOO_SILLY = 'TOO_SILLY',
    TOO_YOUNG = 'TOO_YOUNG',
    VALID_FLAG_VIOLATION = 'VALID_FLAG_VIOLATION',
    EXPIRED = 'EXPIRED',
    IN_HISTORY = 'IN_HISTORY',
}
